"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  ListboxGroup: true
};
exports.default = exports.ListboxGroup = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireWildcard(require("react"));
var _IconButton = require("../IconButton/IconButton");
var _isFunction = require("../utils/isFunction");
var _useUniqueId = _interopRequireDefault(require("../utils/useUniqueId"));
var _listboxUtils = require("./_listboxUtils");
var _ListContext = require("./_ListContext");
var _Listbox = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Listbox.css") : void 0);
var _ListboxGroup = require("./_ListboxGroup.types");
Object.keys(_ListboxGroup).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ListboxGroup[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ListboxGroup[key];
    }
  });
});
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-listbox';
const ListboxGroup = exports.ListboxGroup = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      ariaLabelledby,
      children,
      className,
      label,
      labelHeight,
      labelRef,
      stickyLabel,
      handleClearGroup,
      clearGroupText,
      groupIndex,
      listIdPrefix,
      onClearFocus,
      onClearBlur,
      activeKeys
    } = props,
    otherProps = __rest(props, ["ariaLabelledby", "children", "className", "label", "labelHeight", "labelRef", "stickyLabel", "handleClearGroup", "clearGroupText", "groupIndex", "listIdPrefix", "onClearFocus", "onClearBlur", "activeKeys"]);
  const classnames = _bind.default.bind(_Listbox.default);
  const labelId = (0, _useUniqueId.default)();
  const listContextValue = (0, _react.useContext)(_ListContext.ListContext);
  const {
    isUsingGroups,
    gridLabelClassName,
    isGrid,
    orientation
  } = listContextValue || {};
  const classes = classnames(className, {
    [`${CSS_BLOCK}__group`]: isUsingGroups
  });
  const hasClear = (0, _isFunction.isFunction)(handleClearGroup) && clearGroupText;
  const labelClasses = classnames(`${CSS_BLOCK}__label`, gridLabelClassName, {
    [`${CSS_BLOCK}__label--sticky-group`]: !!stickyLabel,
    [`${CSS_BLOCK}__label--with-clear`]: !!hasClear
  });
  const clearButton = hasClear && (/*#__PURE__*/_react.default.createElement(_IconButton.IconButton, {
    iconName: "close",
    ariaLabel: clearGroupText,
    iconProps: {
      forceSize: 'xs'
    },
    "aria-describedby": `clear-all-${groupIndex}`,
    className: classnames(`${CSS_BLOCK}__clear-group-btn`, {
      [`${CSS_BLOCK}__clear-group-btn--active`]: (activeKeys === null || activeKeys === void 0 ? void 0 : activeKeys.key) === `clear-all-${groupIndex}`
    }),
    onClick: handleClearGroup,
    type: "link",
    id: (0, _listboxUtils.getNodeId)(listIdPrefix, `clear-all-${groupIndex}`, groupIndex),
    "data-clear-group": true,
    onFocus: onClearFocus,
    onBlur: onClearBlur
  }));
  if (isGrid) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, label ? (/*#__PURE__*/_react.default.createElement("span", {
      "aria-hidden": "true",
      className: labelClasses,
      id: labelId,
      role: "presentation"
    }, label, clearButton)) : null, /*#__PURE__*/_react.default.createElement("ul", Object.assign({}, otherProps, {
      "aria-labelledby": (0, _listboxUtils.getAriaLabelledBy)({
        ariaLabelledby,
        label,
        labelId
      }),
      role: isUsingGroups ? 'group' : 'listbox',
      className: classes,
      ref: ref
    }), children));
  }
  let labelStyle;
  if (stickyLabel && labelHeight) {
    let styleProp = 'top';
    if (orientation === 'horizontal') styleProp = 'left';
    labelStyle = {
      [styleProp]: `${labelHeight}px`
    };
  }
  return /*#__PURE__*/_react.default.createElement("ul", Object.assign({}, otherProps, {
    "aria-labelledby": (0, _listboxUtils.getAriaLabelledBy)({
      ariaLabelledby,
      label,
      labelId
    }),
    role: isUsingGroups ? 'group' : 'listbox',
    className: classes,
    ref: ref
  }), label ? (/*#__PURE__*/_react.default.createElement("li", {
    "aria-hidden": "true",
    className: labelClasses,
    id: labelId,
    role: "presentation",
    style: labelStyle,
    ref: labelRef
  }, label, clearButton)) : null, children);
});
ListboxGroup.displayName = 'Listbox.Group';
var _default = exports.default = ListboxGroup;